// extracted by mini-css-extract-plugin
export default {"Box_0":"InlineAutocomplete-module__Box_0--Ovv_s","fullWidth":"InlineAutocomplete-module__fullWidth--X6eXo"};